import { AuthTokenManager, AuthTokenStorage, RouteUrlProvider, SmsFormStateStorage } from 'utils';
import { LockFactory } from 'utils';

import { EventBus } from '../utils';
import { EconomicClassProvider, LegalClassProvider } from '../utils/debtClass';
import { RouteProvider } from '../utils/router/RouteProvider';
import { createAuthManager } from './api-client';

export function createAuthTokenManager(): AuthTokenManager {
  return new AuthTokenManager(
    createAuthManager(),
    new AuthTokenStorage(),
    new LockFactory(window.localStorage)
  );
}

export function createAuthTokenStorage(): AuthTokenStorage {
  return new AuthTokenStorage();
}

export function createRouteUrlProvider(): RouteUrlProvider {
  return new RouteUrlProvider(new RouteProvider());
}

export function createEventBus(): EventBus {
  return new EventBus();
}

export function createSmsFormStateStorage(prefix: string): SmsFormStateStorage {
  return new SmsFormStateStorage(prefix);
}

export function createEconomicClassProvider(): EconomicClassProvider {
  return new EconomicClassProvider();
}

export function createLegalClassProvider(): LegalClassProvider {
  return new LegalClassProvider();
}
